import { withBrowserContext } from '../../src/FiverrContext/withBrowserContext';
import BaseI18n from '../../src/I18n';

export const I18n = withBrowserContext(BaseI18n);
